import React from "react";
import Sidebar from "../partials/aside/Sidebar";
import TitleBar from "../partials/content/TitleBar";

export default function Welcome() {
  return (
    <>
      <Sidebar activeItem="welocome" />

      <div className="content-wrapper">
        <TitleBar title="میزکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body"></div>
          </div>
        </section>
      </div>
    </>
  );
}
